/* jshint esversion: 6 */
/***********************************************************************
 AiccWrappingScormApi
 ************************************************************************
 This API wrappes the AICC data access to the SCORM-Data-Model and
 could be used like a SCORM-API.
 ***********************************************************************/

import {AiccRequestResponse} from "aicc/AiccRequestResponse";
import {RequestService} from "common/RequestService";
import {LoggingService} from "logging/LoggingService";
import {Assert} from "common/Assert";

if (typeof (window.CAiccWrappingScormApi) === "undefined") {
    window.CAiccWrappingScormApi = {};
}

const logId = "AiccRequestService";

export function AiccRequestService(aiccURL, aiccSID, aiccProxy) {
    "use strict";

    Assert.checkArgument(aiccURL);
    Assert.checkArgument(aiccSID);

    const url = aiccProxy,
        aiccUrl = decodeURIComponent(aiccURL),
        aiccSessionID = aiccSID,
        aiccVersion = "3.0",
        lmsErrorCodeMessages = [
            "Invalid aicc command!",
            "Invalid assignable unit!",
            "Invalid session id!"
        ];

    function requestAiccLms(command, data) {
        const responseText = sendHttpMsg(command, data),
            msg = `ERROR on ${command}: Request failed!`;

        if (responseText === "request_error") {
            LoggingService.error(msg, logId);
            return null;
        }

        const response = new AiccRequestResponse(responseText);
        if (checkForLmsError(response)) {
            LoggingService.error(msg, logId);
            return null;
        }

        return response;
    }

    async function requestAsyncAiccLms(command, data) {
        const responseText = await sendAsyncHttpMsg(command, data),
            msg = `ERROR on ${command}: Request failed!`;

        if (responseText === "request_error") {
            LoggingService.error(msg, logId);
            return null;
        }

        const response = new AiccRequestResponse(responseText);
        if (checkForLmsError(response)) {
            LoggingService.error(msg, logId);
            return null;
        }

        return response;
    }

    function sendHttpMsg(command, data) {
        const httpMessage = `aiccurl=${aiccUrl}&command=${encodeURI(command)}&version=${aiccVersion}&sessionid=${encodeURI(aiccSessionID)}&aiccdata=${encodeURI(data)}`;
        return RequestService.sendLmsRequest(url, httpMessage);
    }

    async function sendAsyncHttpMsg(command, data) {
        const httpMessage = `aiccurl=${aiccUrl}&command=${encodeURI(command)}&version=${aiccVersion}&sessionid=${encodeURI(aiccSessionID)}&aiccdata=${encodeURI(data)}`;
        return RequestService.sendAsyncLmsRequest(url, httpMessage);
    }

    function checkForLmsError(response) {

        const errorCodeValue = response.get("error");
        if (!errorCodeValue) {
            return false;
        }

        const errorCode = parseInt(errorCodeValue, 10);
        if (!errorCode || isNaN(errorCode)) {
            return false;
        }

        const defaultLmsErrorMessage = getDefaultLmsErrorMessage(errorCode),
            responseErrorMsg = response.get("error_text");

        let msg = `LMS ERROR - ErrorCode:${errorCode.toString()}`;
        msg += responseErrorMsg ? ` - ErrorText:${responseErrorMsg}` : "";
        msg += defaultLmsErrorMessage ? ` - ErrorText:${defaultLmsErrorMessage}` : "";
        LoggingService.error(msg, logId);

        return true;
    }

    function getDefaultLmsErrorMessage(errorCode) {

        if (errorCode > 0 && errorCode <= lmsErrorCodeMessages.length) {
            return lmsErrorCodeMessages[errorCode - 1];
        }

        return null;
    }

    return {
        getParam: function () {
            return requestAiccLms("GetParam", "");
        },

        putParam: async function (aiccData) {
            Assert.checkArgument(aiccData);
            Assert.checkState(typeof (aiccData) === "string");
            return requestAsyncAiccLms("PutParam", aiccData);
        },

        exitAU: async function () {
            return requestAsyncAiccLms("ExitAU", "");
        }
    };
}
